import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import Box from "@mui/material/Box";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import DeleteImage from "../../../../src/Resources/Images/delete_common.png";

import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TablePagination from "@mui/material/TablePagination";
import TableRow from "@mui/material/TableRow";
import TableSortLabel from "@mui/material/TableSortLabel";
import Typography from "@mui/material/Typography";
import Paper from "@mui/material/Paper";
import IconButton from "@mui/material/IconButton";
import Tooltip from "@mui/material/Tooltip";
import Input from "@mui/material/Input";
import InputAdornment from "@mui/material/InputAdornment";
import { visuallyHidden } from "@mui/utils";
import Button from "@mui/material/Button";
import Grid from "@mui/material/Grid";
import Drawer from "@mui/material/Drawer";
import { ToastError, ToastSuccess } from "../../../UiComponents/Toaster/Toast";
import FloatLabel from "../../../UiComponents/FloatLabel/FloatLabel";
import Autocomplete from "@mui/material/Autocomplete";
import moment from "moment";
import TextField from "@mui/material/TextField";
import { FileUpload, UploadFile } from "@mui/icons-material";
import { FileUploader } from "react-drag-drop-files";
import {
  CloudOffIcon,
  SearchIcon,
  DeleteIcon,
  DownloadIcon,
  EditIcon,
  ReportProblemIcon,
} from "../../../Resources/Icons/icons";

import {
  GetFilterCCEntry,
  getReceivablePolicyData,
  uploadCCEntryData,
  uploadReceivableBulkUploadData,
} from "../../../Service/SearchPolicy";
import { CSVLink } from "react-csv";
import { Dialog } from "@mui/material";
import { DatePicker } from "antd";
import ConfirmBox from "../../../UiComponents/ConfirmBox/ConfirmBox";
import { checkUserType } from "../../../Shared/CommonConstant";
import Loader from "../../../UiComponents/Loader/Loader";
import * as ExcelJS from "exceljs";
import { saveAs } from "file-saver";
import MasterCommonTable from "../../../UiComponents/CommonTable/MasterCommonTable";
import FilterListIcon from "@mui/icons-material/FilterList";
import { Divider, Stack, Badge } from "@mui/material";
import FilterBox from "../../../UiComponents/FilterBox/FilterBox";
import CloudDownloadOutlinedIcon from "@mui/icons-material/CloudDownloadOutlined";
import FilterAltOutlinedIcon from "@mui/icons-material/FilterAltOutlined";
import CustomButton from "../../../UiComponents/CommonBUtton/ConfirmBox";
import wallett from "../../../Resources/Images/wallet.png";
import { multiInputDateRangeFieldClasses } from "@mui/x-date-pickers-pro";
import { GetMasterCompany } from "../../../Service/MasterCompanyService";

const { RangePicker } = DatePicker;

function stableSort(array, comparator) {
  const stabilizedThis = array?.map((el, index) => [el, index]);
  stabilizedThis?.sort((a, b) => {
    const order = comparator(a[0], b[0]);
    if (order !== 0) {
      return order;
    }
    return a[1] - b[1];
  });
  return stabilizedThis?.map((el) => el[0]);
}

function descendingComparator(a, b, orderBy) {
  if (b[orderBy] < a[orderBy]) {
    return -1;
  }
  if (b[orderBy] > a[orderBy]) {
    return 1;
  }
  return 0;
}

function getComparator(order, orderBy) {
  return order === "desc"
    ? (a, b) => descendingComparator(a, b, orderBy)
    : (a, b) => -descendingComparator(a, b, orderBy);
}

const getClassName = (data) => {
  return data.policyNumber ? "file_link" : null;
};

const FilterCCOption = [
  {
    label: "Pending Policy",
    value: "approvePending",
    _id: "approvePending",
  },
  {
    label: "Entry Done",
    value: "entryDone",
    _id: "entryDone",
  },
  {
    label: "Already Exist",
    value: "alreadyExist",
    _id: "alreadyExist",
  },
  {
    label: "Entry Date",
    value: "entryDate",
    _id: "entryDate",
  },
  {
    label: "Approve Date",
    value: "approveDate",
    _id: "approveDate",
  },
];
const tempHeadCells = [
  {
    id: "policyNumber",
    placeMent: true,
    disablePadding: false,
    label: "Policy Number",
  },
  {
    id: "additionalAmount",
    placeMent: true,
    disablePadding: false,
    label: "Add Amount",
  },
  {
    id: "additionalPercentage",
    placeMent: true,
    disablePadding: false,
    label: "Add Percentage",
  },
  {
    id: "uploadedDate",
    placeMent: true,
    disablePadding: false,
    label: "Uploaded Date",
  },
  {
    id: "status",
    placeMent: true,
    disablePadding: false,
    label: "Status",
  },
];

// Added by Arun
const headCells = tempHeadCells;

function EnhancedTableHead(props) {
  const { order, orderBy, onRequestSort } = props;
  const createSortHandler = (property) => (event) => {
    onRequestSort(event, property);
  };

  return (
    <TableHead>
      <TableRow>
        {headCells?.map((headCell) => (
          <TableCell
            className="TableHeader"
            key={headCell.id}
            align={headCell.placeMent ? "left" : "center"}
            padding={headCell.disablePadding ? "none" : "normal"}
            sortDirection={orderBy === headCell.id ? order : false}
            sx={{ fontSize: "16px", fontWeight: 600 }}
            style={{ minWidth: headCells.minWidth }}
          >
            <TableSortLabel
              active={orderBy === headCell.id}
              direction={orderBy === headCell.id ? order : "asc"}
              onClick={createSortHandler(headCell.id)}
            >
              {headCell.label}
              {orderBy === headCell.id ? (
                <Box component="span" sx={visuallyHidden}>
                  {order === "desc" ? "sorted descending" : "sorted ascending"}
                </Box>
              ) : null}
            </TableSortLabel>
          </TableCell>
        ))}
      </TableRow>
    </TableHead>
  );
}

EnhancedTableHead.propTypes = {
  onRequestSort: PropTypes.func.isRequired,
  order: PropTypes.oneOf(["asc", "desc"]).isRequired,
  orderBy: PropTypes.string.isRequired,
};

const ReceivableBulkUpload = () => {
  const styles = {
    label: {
      fontSize: "12px",
      fontFamily: "Inter, sans-serif",
      fontWeight: 400,
      marginBottom: "4px",
      display: "block",
    },
    input: {
      borderRadius: "6px",
      height: 38,
      "& .MuiOutlinedInput-root": {
        borderRadius: "6px",
        height: 38,
      },
    },
    errorText: {
      color: "#d32f2f",
      fontSize: "11px",
      marginTop: "3px",
      fontFamily: "Inter, sans-serif",
    },
  };

  const [order, setOrder] = React.useState("asc");
  const [orderBy, setOrderBy] = React.useState("id");
  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(10);
  const [policyList, setPolicyList] = React.useState([]);
  const [excelList, setExcelList] = React.useState([]);
  const [companyDetails, setCompanyDetails] = useState([]);
  const [walletCompanyId, setWalletCompanyId] = useState("");
  const [bankName, setBankName] = useState("");
  const [remarks, setRemarks] = useState("");
  const [subBookingCodeDetails, setSubBookingCodeDetails] = useState([]);
  const [selectedBookingCode, setSelectedBookingCode] = useState([]);
  const [selectedCompany, setSelectedCompany] = useState([]);
  const [selectedStatus, setSelectedStatus] = useState("");
  const [policyNumber, setPolicyNumber] = useState("");
  const [selectedSubBookingCode, setSelectedSubBookingCode] = useState(null);
  const [openViewCC, setOpenViewCC] = useState(false);
  const [resetValue, setResetValue] = useState(1);
  const [selectedData, setSelectedData] = useState({});
  const [edit, setEdit] = useState("");
  const [selectedStartDate, setSelectedStartDate] = useState();
  const [selectedEndtDate, setSelectedEndDate] = useState();
  const [openLoader, setOpenLoader] = useState(false);
  const [filterBy, setFilterBy] = useState({});
  const [bulkUpdateProgress, setBulkUpdateProgress] = useState(0);
  const [bulkUpdateMessage, setBulkUpdateMessage] = useState("");
  const [openConfirmBox, setOpenConfirmBox] = useState(false);
  const [approvePending, setApprovePending] = useState(false);
  const [filteredCells, setFilteredCells] = useState(headCells);
  const [receivableFile, setReceivableFile] = useState(null);
  const [bulkUpdateFile, setBulkUpdateFile] = useState(null);
  const [status, setStatus] = useState("");
  const [uploadSummary, setUploadSummary] = useState([]);
  const [showSummaryModal, setShowSummaryModal] = useState(false);
  const [filter, setFilter] = useState({
    fn: (items) => {
      return items;
    },
  });
  const csvLinkRef = React.useRef(null);
  const [resetFileKey, setResetFileKey] = useState(1);

  const [searchText, setSearchText] = useState("");
  const [tableConfig, setTableConfig] = useState({
    isAction: false,
    isView: true,
    isEdit: true,
  });
  const [dateRange, setDateRange] = useState([]);

  const downloadExcel = async () => {
    // await apiCallForDownloadExcel();
    console.log("csvLinkRef.current.link : ", csvLinkRef.current.link);
    console.log("header ", csvFile.headers);
    if (csvLinkRef.current) {
      csvLinkRef.current.link.click(); // Trigger the CSV download
    }
  };
  // For pagination
  const [count, setCount] = useState(0);
  const [totalPremium, setTotalPremium] = useState(0);
  const defaultQueryParams = {
    page: 0,
    limit: 10,
    search: "",
    skip: 0,
    sort: "",
    isDownloadExcel: false,
  };
  const [queryParam, setQueryParam] = useState(defaultQueryParams);
  const [isInitialized, setIsInitialized] = useState(false);

  // const visibleRows = React.useMemo(
  //   () =>
  //     stableSort(filter.fn(FilteredData), getComparator(order, orderBy))?.slice(
  //       page * rowsPerPage,
  //       page * rowsPerPage + rowsPerPage
  //     ),
  //   [order, orderBy, page, rowsPerPage, filter, FilteredData]
  // );

  // Added by Arun
  const resetQueryParams = () => {
    setQueryParam(defaultQueryParams);
    setPage(0);
  };

  const handleRequestSort = (event, property) => {
    const isAsc = orderBy === property && order === "asc";
    setOrder(isAsc ? "desc" : "asc");
    setOrderBy(property);
  };

  const handleChangePage = (event, newPage) => {
    console.log("newPage ", newPage);
    setQueryParam({
      ...queryParam,
      page: newPage,
      skip: newPage * rowsPerPage,
    });
    setPage(newPage);
  };

  const GetCompanyDetails = () => {
    GetMasterCompany().then((res) => {
      const modifiedCompanyDetails = res.data
        .map((e) => {
          if (e.isEnabled) {
            return {
              ...e,
              label: e.masterCompanyName,
              value: e._id,
            };
          } else {
            return null;
          }
        })
        .filter(Boolean);
      setCompanyDetails(modifiedCompanyDetails);
    });
  };

  const GetReceivablePolicyData = () => {
    setOpenLoader(true);
    getReceivablePolicyData()
      .then((res) => {
        const list = res.data || [];
        setPolicyList(list);
        setCount(list.length);
      })
      .finally(() => {
        setOpenLoader(false);
      });
  };

  const uploadExcel = async () => {
    if (!receivableFile) {
      ToastError("Please upload excel data");
      return true;
    }

    setOpenLoader(true);
    try {
      const workbook = new ExcelJS.Workbook();
      const buffer = await receivableFile.arrayBuffer();
      await workbook.xlsx.load(buffer);

      const worksheet = workbook.worksheets[0];
      if (!worksheet) {
        ToastError("Uploaded file does not contain a worksheet.");
        return;
      }

      const rowsData = [];
      let headerRow = [];

      worksheet.eachRow((row, rowNumber) => {
        const values = row.values;
        if (rowNumber === 1) {
          headerRow = values
            .slice(1)
            .map((cell) =>
              cell !== undefined && cell !== null ? String(cell).trim() : "",
            );
          return;
        }

        if (headerRow.length === 0) {
          return;
        }

        const rowObject = {};
        headerRow.forEach((header, index) => {
          rowObject[header] =
            values[index + 1] !== undefined ? values[index + 1] : "";
        });

        rowsData.push(rowObject);
      });

      // Validate required columns (case-insensitive, tolerant to small variations)
      const normalizedHeaders = headerRow
        .map((h) =>
          String(h || "")
            .trim()
            .toLowerCase(),
        )
        .filter(Boolean);

      const matchesAny = (patterns) =>
        patterns.some((p) => normalizedHeaders.some((h) => p.test(h)));

      const requiredFields = [
        { key: "User Name", patterns: [/\busername\b/, /\buser\s*name\b/] },
        {
          key: "Policy Number",
          patterns: [/\bpolicy\b.*\bnumber\b/, /policynumber/],
        },
        {
          key: "Additonal %",
          patterns: [
            /\b(add|additional|additonal)\b.*(%|percent|percentage)/,
            /%/,
            /additionalpercentage/,
          ],
        },
        {
          key: "Add Amt",
          patterns: [
            /\b(add|additional)\b.*\b(amount|amt)\b/,
            /additionalamt/,
            /additionalamount/,
          ],
        },
      ];

      const missing = requiredFields
        .filter((f) => !matchesAny(f.patterns))
        .map((f) => f.key);
      if (missing.length > 0) {
        setOpenLoader(false);
        ToastError(`Missing required column(s): ${missing.join(", ")}`);
        return;
      }

      // Warn about any unexpected/new columns (do not block upload)
      const recognizedPatterns = requiredFields.flatMap((f) => f.patterns);
      const extraHeaders = headerRow.filter((h) => {
        const nh = String(h || "")
          .trim()
          .toLowerCase();
        if (!nh) return false;
        return !recognizedPatterns.some((p) => p.test(nh));
      });
      if (extraHeaders.length > 0) {
        ToastError(
          `Warning: Unexpected column(s) found: ${extraHeaders.join(", ")}`,
        );
        return;
      }

      const usernameField = headerRow.find((header) => {
        const normalized = String(header || "")
          .trim()
          .toLowerCase();
        return normalized === "username" || normalized === "user name";
      });

      const amountField = headerRow.find((header) => {
        const normalized = String(header || "")
          .trim()
          .toLowerCase();
        return (
          normalized === "add amount" ||
          normalized === "add amt" ||
          normalized === "additionalamt"
        );
      });

      const summaryMap = rowsData.reduce((summary, row) => {
        let username = "Unknown";
        if (
          usernameField &&
          row[usernameField] !== undefined &&
          row[usernameField] !== null
        ) {
          username = String(row[usernameField]).trim() || "Unknown";
        } else if (row.userName || row.user_name || row.UserName) {
          username =
            String(row.userName || row.user_name || row.UserName).trim() ||
            "Unknown";
        }

        let additionalAmount = 0;
        if (
          amountField &&
          row[amountField] !== undefined &&
          row[amountField] !== null
        ) {
          const cleaned = String(row[amountField]).replace(/,/g, "").trim();
          const parsed = parseFloat(cleaned);
          additionalAmount = Number.isFinite(parsed) ? parsed : 0;
        } else if (row.additionalAmount || row.addAmount || row.add_amt) {
          const raw = row.additionalAmount || row.addAmount || row.add_amt;
          const cleaned = String(raw).replace(/,/g, "").trim();
          const parsed = parseFloat(cleaned);
          additionalAmount = Number.isFinite(parsed) ? parsed : 0;
        }

        if (!summary[username]) {
          summary[username] = {
            username,
            totalAdditionalAmount: 0,
          };
        }

        summary[username].totalAdditionalAmount += additionalAmount;
        return summary;
      }, {});

      // console.log("rowsData ", rowsData);
      // console.log("summary ", summaryMap);

      const summaryList = Object.values(summaryMap)
        .map((item) => ({
          ...item,
          totalAdditionalAmount: Number(
            item.totalAdditionalAmount || 0,
          ).toFixed(2),
        }))
        .sort((a, b) => a.username.localeCompare(b.username));

      setExcelList(rowsData);
      setUploadSummary(summaryList);
      setShowSummaryModal(true);

      if (rowsData.length === 0) {
        ToastError("No rows were read from the Excel file.");
      } else {
        ToastSuccess(`Loaded ${rowsData.length} row(s) from Excel.`);
      }
    } catch (error) {
      console.error("Error reading Excel file:", error);
      ToastError("Failed to read Excel data. Please check the file format.");
    } finally {
      setOpenLoader(false);
    }
  };

  const getRandomNumberUsingTimestamp = () => {
    const timestamp = new Date().getTime();
    return timestamp;
  };

  const handleSummarySubmit = async () => {
    if (!walletCompanyId || !bankName?.trim() || !remarks?.trim()) {
      ToastError(
        "Please select company, enter bank name, and add remarks before submitting.",
      );
      return;
    }

    setShowSummaryModal(false);

    let formData = new FormData();
    formData.append(receivableFile, receivableFile);
    formData.append("companyId", walletCompanyId);
    formData.append("bankName", bankName);
    formData.append("remark", remarks);
    formData.append("policyNumber", getRandomNumberUsingTimestamp().toString()); // Using timestamp as a unique identifier for this upload session
    // formData.append("policyData", JSON.stringify(excelList));
    formData.append("summaryData", JSON.stringify(uploadSummary)); // Adjust as needed
    console.log("Payload to submit: ", formData);
    setOpenLoader(true);
    await uploadReceivableBulkUploadData(formData)
      .then((res) => {
        if (res?.message) {
          ToastSuccess(res.message);
          // setReceivableFile(null);
        }
        // UniversalSearch(true);
      })
      .finally(() => {
        setOpenLoader(false);
      });
  };

  const handleSummaryClose = () => {
    setShowSummaryModal(false);
    setUploadSummary([]);
    setExcelList([]);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setQueryParam({ ...queryParam, limit: event.target.value, page: 0 });
    setPage(0);
  };

  const onSearch = (e) => {
    const target = e.target.value;
    setSearchText(target);
    setQueryParam({
      ...queryParam,
      search: target,
      page: 0,
      skip: 0,
    });
    setPage(0);
  };

  const FilteredData = policyList?.filter((el) => {
    const searchTerm = searchText.toLowerCase();
    const policyListDetails =
      `${el?.policyNumber},${el?.additionalAmount},${el?.additionalPercentage},${el?.uploadedDate},${el?.status}`.toLowerCase();
    return policyListDetails.includes(searchTerm);
  });
  const totalCount = FilteredData?.length || 0;

  const UniversalSearch = async () => {
    setPolicyList([]);
    setExcelList([]);
  };

  const apiCallForDownloadExcel = async () => {
    setPolicyList([]);
    setExcelList([]);
  };
  const handleDownload = () => {
    const link = document.createElement("a");
    link.href = "/files/receivable-sample-data.xlsx"; // Path in the public folder
    link.download = "receivable-sample-data.xlsx";
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  const handleButton = (row) => {};

  // Builds headCells with a per-row renderComponent for the Action column
  const getHeadCellsWithAction = () => {
    return headCells.map((col) => {
      if (col.id === "action") {
        return {
          ...col,
          renderComponent: (row) => {
            // if (!row?.ticketNumber) {
            //   // No ticket number → show CC Entry button
            //   return (
            //     <Button
            //       variant="contained"
            //       color="primary"
            //       className="CCEntry_Table_Button"
            //       onClick={() => {
            //         CCEntryFunction(row);
            //         setEdit("ccEntry");
            //       }}
            //     >
            //       CC Entry
            //     </Button>
            //   );
            // }
          },
        };
      }
      return col;
    });
  };

  // let totalPremium = 0;
  // policyList?.map((row) => {
  //   const premiumWithoutCommas = row?.totalPremium.replace(/,/g, "");
  //   let totPremium = parseFloat(premiumWithoutCommas);
  //   totalPremium += totPremium;
  // });

  const tempHeader = [
    { header: "Policy Number", key: "policyNumber" },
    { header: "Additional Amount", key: "additionalAmount" },
    { header: "Additional Percentage", key: "additionalPercentage" },
    { header: "Uploaded Date", key: "uploadedDate" },
    { header: "Status", key: "status" },
  ];

  const header = tempHeader;

  const csvFile = {
    filename: "CC Entry Data",
    headers: header,
    data: excelList,
  };

  const handleClearAllState = () => {
    setSelectedBookingCode([]);
    setSelectedSubBookingCode(null);
    setSelectedCompany([]);
    setSelectedStatus(null);
    setPolicyNumber(null);
    setDateRange([]);
    // Clear the policy list since booking code is required for fetching data
    setPolicyList([]);
    setExcelList([]);
    setCount(0);
    setTotalPremium(0);
    setQueryParam(defaultQueryParams);
    setPage(0);
  };

  const handleClearSingleFilter = async (filterId) => {
    // Check if booking code is selected before clearing (required for API call)
    const hasBookingCode =
      selectedBookingCode && selectedBookingCode.length > 0;

    if (!hasBookingCode && filterId !== 1) {
      // Can't fetch without booking code
      return;
    }

    // Prepare cleared values based on filter ID
    let clearedCompany = selectedCompany;
    let clearedDateRange = dateRange;
    let clearedStatus = selectedStatus;
    let clearedPolicyNumber = policyNumber;
    let clearedBookingCode = selectedBookingCode;

    // Clear the specific filter based on ID
    if (filterId === 1) {
      // Clear Booking Code
      setSelectedBookingCode([]);
      setSelectedSubBookingCode(null);
      clearedBookingCode = [];
      // Can't fetch without booking code, so don't call API
      return;
    } else if (filterId === 2) {
      // Clear Company
      setSelectedCompany([]);
      clearedCompany = [];
    } else if (filterId === 3) {
      // Clear Date
      setDateRange([]);
      clearedDateRange = [];
    } else if (filterId === 4) {
      // Clear Status/Filter
      setSelectedStatus(null);
      clearedStatus = null;
    } else if (filterId === 5) {
      // Clear Policy Number
      setPolicyNumber(null);
      clearedPolicyNumber = null;
    }

    // Fetch data with cleared filter values
    setOpenLoader(true);
    try {
      const res = await GetFilterCCEntry();
      setOpenLoader(false);
      const FilteredData = res?.data?.tableData.map((e) => {
        return {
          ...e,
          issueDate: e.issueDate
            ? moment(e.issueDate).format("DD/MM/YYYY")
            : e.issueDate,
          InformatDate: moment(e.issueDate).format("DD/MM/YYYY"),
        };
      });
      if (!queryParam.isDownloadExcel) {
        setPolicyList(FilteredData);
      }
      setExcelList(FilteredData);
      setCount(res?.data?.totalRecords);
      setTotalPremium(res?.data?.totalPremium);
      setPage(0);
    } catch (error) {
      setOpenLoader(false);
      console.error("Error filtering CC Entry:", error);
      ToastError("Failed to filter data. Please try again.");
    }
  };

  const [searchTrigger, setSearchTrigger] = useState(0);

  const handleSaveAllFilter = () => {
    if (!selectedBookingCode || selectedBookingCode.length === 0) {
      ToastError("Please select a Booking Code before applying filters!");
      return;
    }
    setFilteredCells(getHeadCellsWithAction());
    setTableConfig({
      isAction: false,
      isView: false,
      isEdit: false,
      isDelete: false,
    });
    setQueryParam((prev) => ({
      ...prev,
      page: 0,
      skip: 0,
    }));
    setPage(0);
    setSearchTrigger((prev) => prev + 1);
  };

  useEffect(() => {
    GetCompanyDetails();
    GetReceivablePolicyData();
  }, []);

  useEffect(() => {
    if (searchTrigger > 0) {
      UniversalSearch();
    }
  }, [searchTrigger]);

  const filterBoxData = [
    {
      id: 1,
      label: "Select Booking and Sub Booking Code",
      data: subBookingCodeDetails,
      setState: setSelectedBookingCode,
      value: selectedBookingCode,
      type: "input",
      variation: "multiple",
      multiple: true,
    },
    {
      id: 2,
      label: "Select Company",
      data: companyDetails,
      setState: setSelectedCompany,
      value: selectedCompany,
      type: "input",
      variation: "multiple",
      multiple: true,
    },
    {
      id: 3,
      label: "Select Date",
      setDate: (range) => {
        setDateRange(range);
        setSearchTrigger((prev) => prev + 1);
      },
      value: dateRange,
      type: "noDefaultDate",
    },
    {
      id: 4,
      label: "Filter",
      data: FilterCCOption,
      // setState: (e) => {
      //   console.log("e", e?._id);
      //   let option = FilterCCOption.find((el) => el._id === e);
      //   setSelectedStatus(option.value);
      // },
      // value: FilterCCOption.find(opt => opt.value === selectedStatus)?._id,
      setState: setSelectedStatus,
      value: selectedStatus,
      type: "input",
      variation: "single",
    },
    {
      id: 5,
      label: "Policy Number",
      setState: setPolicyNumber,
      value: policyNumber,
      type: "normalInput",
    },
  ];

  const [showFilter, setShowFilter] = useState(false);

  const activeFiltersCount = [
    selectedBookingCode?.length > 0 ? 1 : 0,
    selectedCompany?.length > 0 ? 1 : 0,
    dateRange?.length > 0 ? 1 : 0,
    selectedStatus,
    policyNumber,
  ].filter(Boolean).length;

  return (
    <>
      <div>
        <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
          <Box sx={{ position: "relative", zIndex: 1, mt: 0 }}>
            <Grid container className="Master_Card_Container">
              <Grid
                container
                alignItems={"center"}
                className="Master_Card_Sub_Container"
                sx={{ mb: 2 }}
              >
                <Grid item xs={12} sm={6} md={4}>
                  <Typography className="Master_Card_Tittle">
                    User Additional
                  </Typography>
                </Grid>
                <Grid
                  item
                  xs={12}
                  sm={12}
                  md={8}
                  className="d-flex"
                  justifyContent={{
                    xs: "start",
                    sm: "flex-end",
                    md: "flex-end",
                  }}
                >
                  <Stack
                    direction={{ xs: "column", sm: "row", md: "row" }}
                    spacing={2}
                    mt={{ xs: 2, sm: 2, md: 0 }}
                    sx={{ width: "100%", justifyContent: "flex-end" }}
                  >
                    {/* <Button
                      className="Master_Card_Filter_Button"
                      sx={{ width: "102px", height: "35px", gap: "8px" }}
                      startIcon={
                        <Badge
                          badgeContent={activeFiltersCount}
                          sx={{
                            "& .MuiBadge-badge": {
                              right: 5,
                              top: 3,
                              width: "14px",
                              height: "14px",
                              minWidth: "14px",
                              borderRadius: "50%",
                              fontSize: "8.91px",
                              fontWeight: "600",
                              backgroundColor: "#E50000",
                              color: "#fff",
                              padding: 0,
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                            },
                          }}
                        >
                          <FilterListIcon sx={{ marginRight: "1.5px" }} />
                        </Badge>
                      }
                      onClick={() => setShowFilter(!showFilter)}
                    >
                      Filters
                    </Button> */}

                    <Box
                      sx={{
                        height: "35px",
                        "& > label": { height: "100%" },
                        minWidth: "150px",
                      }}
                    >
                      <FileUploader
                        handleChange={(e) => {
                          // console.log("e", e);
                          setReceivableFile(e);
                        }}
                        fileOrFiles={receivableFile}
                        name="receivableFile"
                        label="Upload Excel"
                        dropMessageStyle={{
                          color: "red",
                          border: "none",
                          borderRadius: "0px",
                        }}
                        types={["XLSX", "XLS"]}
                        key={resetFileKey}
                      />
                    </Box>
                    <Button
                      className="Master_Header_create_Button"
                      onClick={() => {
                        uploadExcel();
                      }}
                      endIcon={<FileUpload />}
                      sx={{
                        height: "35px !important",
                        backgroundColor: "#1E3A5F",
                        color: "#fff",
                        gap: 2,
                        minWidth: "150px",
                        "&:hover": {
                          backgroundColor: "#0056CC",
                        },
                      }}
                    >
                      Import Data
                    </Button>
                    <Button
                      className="Master_Header_create_Button"
                      onClick={() => {
                        handleDownload();
                      }}
                      endIcon={<DownloadIcon />}
                      sx={{
                        height: "35px !important",
                        backgroundColor: "#1E3A5F",
                        color: "#fff",
                        gap: 2,
                        minWidth: "150px",
                        "&:hover": {
                          backgroundColor: "#0056CC",
                        },
                      }}
                    >
                      Sample Data
                    </Button>
                    <Button
                      className="Master_Card_Filter_Button"
                      sx={{
                        height: "40px",
                        gap: "8px",
                        minWidth: "120px",
                      }}
                      startIcon={
                        <CloudDownloadOutlinedIcon
                          sx={{
                            color: "#344054",
                          }}
                        />
                      }
                      size="small"
                      variant="outlined"
                      onClick={() => {
                        apiCallForDownloadExcel();
                      }}
                    >
                      Export
                    </Button>
                  </Stack>
                  {/* Summary Modal */}
                  <Dialog
                    open={showSummaryModal}
                    onClose={handleSummaryClose}
                    maxWidth="sm"
                    fullWidth
                  >
                    <Box sx={{ p: 3 }}>
                      <Typography
                        sx={{ fontWeight: 600, mb: 2, fontSize: "18px" }}
                      >
                        Excel Upload Summary
                      </Typography>
                      <Typography sx={{ mb: 3, color: "#666" }}>
                        Please review the summary below before proceeding:
                      </Typography>

                      <Grid
                        item
                        xs={12}
                        sm={6}
                        sx={{
                          mb: 3,
                        }}
                      >
                        <label htmlFor="walletCompanyId" style={styles.label}>
                          Select Company <span style={{ color: "red" }}>*</span>
                        </label>
                        <Autocomplete
                          className="AutoComplete_InputBox w-100"
                          name="walletCompanyId"
                          id="walletCompanyId"
                          onChange={(e, v) => {
                            setWalletCompanyId(v?._id);
                          }}
                          options={companyDetails}
                          clearIcon={false}
                          renderInput={(params) => (
                            <TextField
                              {...params}
                              sx={{
                                ...styles.input,
                              }}
                            />
                          )}
                          isOptionEqualToValue={(option, value) =>
                            option._id === value?._id
                          }
                        />
                      </Grid>

                      <Grid
                        item
                        xs={12}
                        sm={6}
                        sx={{
                          mb: 3,
                        }}
                      >
                        <label htmlFor="bankName" style={styles.label}>
                          Bank Name
                        </label>
                        <TextField
                          id="bankName"
                          name="bankName"
                          value={bankName}
                          onChange={(e) => setBankName(e.target.value)}
                          className="InputFiled"
                          style={styles.input}
                        />
                      </Grid>

                      <Grid
                        item
                        xs={12}
                        sm={6}
                        sx={{
                          mb: 3,
                        }}
                      >
                        <label htmlFor="remarks" style={styles.label}>
                          Remark
                        </label>
                        <TextField
                          id="remarks"
                          name="remarks"
                          value={remarks}
                          onChange={(e) => setRemarks(e.target.value)}
                          multiline
                          minRows={1}
                          maxRows={4}
                          className="InputFiled"
                          style={styles.input}
                        />
                      </Grid>

                      <Box
                        sx={{
                          mb: 3,
                          p: 2,
                          backgroundColor: "#f5f5f5",
                          borderRadius: 1,
                        }}
                      >
                        {uploadSummary.map((item) => (
                          <Typography
                            key={item.username}
                            sx={{ fontSize: "14px", mb: 1 }}
                          >
                            <strong>{item.username}:</strong> Total Additional
                            Amt: {item.totalAdditionalAmount}
                          </Typography>
                        ))}
                      </Box>
                      <Box
                        sx={{
                          display: "flex",
                          gap: 2,
                          justifyContent: "flex-end",
                          mt: 3,
                        }}
                      >
                        <Button
                          variant="outlined"
                          onClick={handleSummaryClose}
                          sx={{ minWidth: "100px" }}
                        >
                          Cancel
                        </Button>
                        <Button
                          variant="contained"
                          color="primary"
                          onClick={handleSummarySubmit}
                          sx={{ minWidth: "100px", backgroundColor: "#1E3A5F" }}
                        >
                          Submit
                        </Button>
                      </Box>
                    </Box>
                  </Dialog>
                  {/* \u003cGrid item xs={12} sm={6} /\u003e */}
                </Grid>
              </Grid>

              {/* Filter Section */}
              {showFilter && (
                <Box
                  sx={{
                    mb: 2,
                    overflow: "visible",
                    position: "relative",
                    zIndex: 1200,
                    minHeight: "60px",
                    width: "100%",
                  }}
                >
                  <FilterBox
                    filterData={filterBoxData}
                    type={"single"}
                    handleClearAllState={handleClearAllState}
                    handleSaveAllFilter={handleSaveAllFilter}
                    handleClearSingleFilter={handleClearSingleFilter}
                    horizontalLayout={true}
                    hideHeader={true}
                    hideInput={true}
                    alwaysOpen={true}
                    autoApply={false}
                  />
                </Box>
              )}
              <Grid item xs={12}>
                <Divider
                  sx={{
                    backgroundColor: "#EAECF0",
                    borderWidth: 1,
                  }}
                />
              </Grid>

              <Grid
                container
                alignItems={"center"}
                justifyContent={"space-between"}
                sx={{ margin: "0px 10px" }}
                // className="Master_Card_Sub_Container"
              >
                {/* <Grid
                  item
                  xs={12}
                  sm={4}
                  md={3.1}
                  mt={{ xs: 2, sm: 0, md: 0 }}
                  sx={{ display: "flex" }}
                >
                  <Grid
                    item
                    marginLeft={2}
                    margin={1}
                    sx={{
                      display: "flex",
                      alignItems: "center",
                    }}
                  >
                    <Button
                      className="Master_Card_Filter_Button"
                      sx={{
                        height: "40px",
                        gap: "8px",
                        minWidth: "120px",
                      }}
                      startIcon={
                        <CloudDownloadOutlinedIcon
                          sx={{
                            color: "#344054",
                          }}
                        />
                      }
                      size="small"
                      variant="outlined"
                      onClick={() => {
                        apiCallForDownloadExcel();
                      }}
                    >
                      Export
                    </Button>
                  </Grid>
                </Grid> */}
                <Grid item xs={12} sm={4} md={3.1} mt={{ xs: 2, sm: 0, md: 0 }}>
                  <Input
                    focused="false"
                    className="w-100 Master_Card_Input"
                    id="standard-adornment-password"
                    onChange={onSearch}
                    // onChange={(e) => {
                    //   onSearch(e.target.value);
                    // }}
                    disableUnderline={true}
                    placeholder="Search"
                    startAdornment={
                      <InputAdornment
                        position="start"
                        sx={{ marginRight: "0px" }}
                      >
                        <IconButton aria-label="toggle password visibility">
                          <SearchIcon
                            sx={{
                              fontSize: "20px",
                            }}
                          />
                        </IconButton>
                      </InputAdornment>
                    }
                  />
                </Grid>
              </Grid>
              <MasterCommonTable
                tableConfig={tableConfig}
                data={FilteredData}
                columns={filteredCells}
                handleButton={{ "CC Entry": handleButton }}
                handleEdit={(row) => {}}
                isServerSide={false}
                tableTotalCount={totalCount}
                loading={openLoader}
                // limit={rowsPerPage}
                paginationReset={searchTrigger + queryParam.search}
              />
            </Grid>
          </Box>
        </Box>
      </div>
      {/* <Loader open={openLoader} /> */}

      {useEffect(() => {
        if (!openViewCC) {
          window.scrollTo({ top: 0, behavior: "smooth" });
        }
      }, [openViewCC])}
    </>
  );
};
export default ReceivableBulkUpload;
